'use client'

import { LargeSuccessIcon } from '@repo/ui/LargeSuccessIcon'
import { openInBundledocs } from '../DocumentBundlesModule/openInBundledocs'
import { useDocumentBundleAuthStore } from '@repo/store/useDocumentBundleAuthStore'
import { useDocumentBundleWizardStore } from '@repo/store/useDocumentBundleWizardStore'
import { useMatterBundleStore } from '@repo/store/useMatterBundleStore'
import { useMattersStore } from '@repo/store/useMattersStore'
import { useUrlStore } from '@repo/store/useUrlStore'
import { useWizardStore } from '@repo/store/useWizardStore'
import { WizardFooter } from '@repo/ui/WizardFooter'
import { WizardPanel } from '@repo/ui/WizardPanel'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import MUIButton from '@mui/material/Button'

type StepProps = {
  wideMode?: boolean
  handlePrevNext: any
  updateStepState: any
}

export const DocumentBundlesSummary = ({ wideMode, handlePrevNext, updateStepState }: StepProps) => {
  const { reset: resetWizardStore } = useWizardStore()
  const {
    reset: resetDocumentBundleWizardStore,
    selectedMatter,
    bundledocsPartitionKey,
    bundledocsRowKey
  } = useDocumentBundleWizardStore()
  const { reset: resetDocumentBundleAuthStore } = useDocumentBundleAuthStore()
  const { navigateWithClientMatterNo } = useUrlStore()
  const { currentMatter } = useMattersStore()
  const { fetchMatterBundles } = useMatterBundleStore()

  const handleOpenBundledocs = async () => {
    handleFinish();
    await openInBundledocs({
      clientNo: selectedMatter?.clientNo,
      matterNo: selectedMatter?.matterNo,
      bundledocsPartitionKey,
      bundledocsRowKey
    })
  }

  const handleFinish = () => {
    updateStepState({
      status: 'completed',
      statusText: 'Complete'
    })

    if (currentMatter?.clientNo && currentMatter?.matterNo) {
      fetchMatterBundles({ clientNo: currentMatter.clientNo, matterNo: currentMatter.matterNo })
    }

    resetWizardStore()
    resetDocumentBundleWizardStore()
    resetDocumentBundleAuthStore()

    navigateWithClientMatterNo({ route: 'case-management/matters/document-bundles' })
  }

  return (
    <>
      <WizardPanel data-testid="DocumentBundleSummary">
        <MUIStack
          alignItems="center"
          justifyContent="center"
          spacing={4}
          sx={{
            width: '100%',
            minHeight: '430px',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: '4px',
            backgroundColor: 'white'
          }}
        >
          <LargeSuccessIcon sx={{ width: '90px', height: '90px', mb: '32px' }} />

          <MUITypography
            variant="h4"
            sx={{
              mb: 0
            }}
          >
            Last step!
          </MUITypography>

          <MUITypography
            variant="body1"
            align="center"
            sx={{
              maxWidth: '520px'
            }}
          >
            Your bundle has been created. Please click the button below to open it directly in Bundledocs, otherwise
            please click Finish.
          </MUITypography>

          <MUIButton
            variant="contained"
            color="primary"
            onClick={handleOpenBundledocs}
            sx={{
              minWidth: '110px'
            }}
          >
            Open Bundledocs
          </MUIButton>
        </MUIStack>
      </WizardPanel>

      <WizardFooter
        wideMode={wideMode}
        handleClickBack={() => handlePrevNext(-1)}
        handleClickContinue={handleFinish}
        continueButtonText="Finish"
      />
    </>
  )
}